import $ from 'jquery';

const SELECTORS = {
    ACCORDIION_ARROW: '.accordion-arrow',
    ACCORDION_CONTENT: '.accordion-content',
    ACCORDION_TITLE: '.accordion-title',
    ACCORDION_TITLE_TEXT: '.accordion-title-key-text',
    ORDER_DETAILS_MODAL: '.order-details-modalChild',
    ORDER_DETAILS_MODAL_CLOSE: '.order-details-modal-close-icon',
    SERIAL_COLUMN_CONTENT: 'serial_column_content'
}

const CLASSES = {
    ARROW_UP_ACCORDION: 'accordion-arrow-up',
    HIDE_ACCORDION: 'accordion-hide',
    HIDE_MODAL: 'order-details-modal-hide'
}

export default class OrderHistoryView {
    
    constructor($element) {
        return this.init($element)
    }

    init($element) {
        this.$element = $element;

        return this.setupHandlers()
            .createChildren()
            .enable();
    }

    setupHandlers() {
        this.onSerialColumnContentClickHandler = this.onSerialColumnContentClick.bind(this);
        this.onOrderDetailsModelCloseClickHandler = this.onOrderDetailsModelCloseClick.bind(this);
        this.onAccordionTitleClickHandler = this.onAccordionTitleClick.bind(this);

        this.onClickOutHandler = this.onClickOut.bind(this);

        return this;
    }

    onSerialColumnContentClick(e) {
        this.hideOrderDetailsModals();
        $(e.currentTarget).next(SELECTORS.ORDER_DETAILS_MODAL).toggleClass(CLASSES.HIDE_MODAL);
    }

    hideOrderDetailsModals() {
        $(SELECTORS.ORDER_DETAILS_MODAL).addClass(CLASSES.HIDE_MODAL);
    }

    onAccordionTitleClick(e) {
        const target = $(e.currentTarget);
        const accordionContent = target.next(SELECTORS.ACCORDION_CONTENT);
        const text = accordionContent.hasClass(CLASSES.HIDE_ACCORDION) === true ? 'Hide Details' : 'View Details';
        target.find(SELECTORS.ACCORDION_TITLE_TEXT).text(text);

        target.find(SELECTORS.ACCORDIION_ARROW).toggleClass(CLASSES.ARROW_UP_ACCORDION);
        accordionContent.toggleClass(CLASSES.HIDE_ACCORDION);
    }

    onOrderDetailsModelCloseClick(e) {
        this.hideOrderDetailsModals();
    }

    onClickOut(e) {
        e.stopImmediatePropagation();
        if (!this.isClickTarget(e.target, SELECTORS.ORDER_DETAILS_MODAL) && e.target.classList.contains(SELECTORS.SERIAL_COLUMN_CONTENT) === false) {
            this.hideOrderDetailsModals();
        }
    }

    isClickTarget(target, selector) {
        return $(target).closest(selector).length;
    }

    createChildren() {
        this.$serialColumnContent = this.$element.find('.' + SELECTORS.SERIAL_COLUMN_CONTENT);
        this.$accordionTitle = this.$element.find(SELECTORS.ACCORDION_TITLE);
        this.$orderDetailsModalClose = this.$element.find(SELECTORS.ORDER_DETAILS_MODAL_CLOSE);

        return this;
    }

    enable() {
        $(document).on('click', this.onClickOutHandler);
        this.$accordionTitle.on('click', this.onAccordionTitleClickHandler);
        this.$serialColumnContent.on('click', this.onSerialColumnContentClickHandler);
        this.$orderDetailsModalClose.on('click', this.onOrderDetailsModelCloseClickHandler);

        return this;
   }

    disable() {
        $(document).off('click', this.onClickOutHandler);
        this.$accordionTitle.off('click', this.onAccordionTitleClickHandler);
        this.$serialColumnContent.off('click', this.onSerialColumnContentClickHandler);
        this.$orderDetailsModalClose.off('click', this.onOrderDetailsModelCloseClickHandler);

        return this;
    }
}